import React from "react";
import PropTypes from "prop-types";

import Component from "components/component";

export default class QuantityCounter extends Component {
  static propTypes = {
    quantityCount: PropTypes.number.isRequired,
    increaseQuantity: PropTypes.func.isRequired,
    decreaseQuantity: PropTypes.func.isRequired
  };

  render() {
    const { quantityCount, increaseQuantity, decreaseQuantity } = this.props;

    return (
      <div className="quantity-button product-quote-row-cell">
        <span className="quantity-decrease" onClick={decreaseQuantity}>
          -
        </span>
        <span className="quantity-amount">{quantityCount}</span>
        <span className="quantity-increase" onClick={increaseQuantity}>
          +
        </span>
      </div>
    );
  }
}
